export const UDPATE_DELAY = 20000;
